export class Usuario{

  constructor(

    public nombrecliente: string,
    public apellido: string,
    public emailpersonal: string,
    public dirigido?: string,
    public activado?: boolean,
    public password?: string,
    public idempresa?: object,
    public admin?: boolean,
    public role?: string,
    public color?: string,
    public alias?: string,
    public _id?: string,
    public status?: string,
    public folio?: string,
    public tiempo?: string,
    public enlinea?: boolean,
    public servidormtto?: boolean,
    public sonidoNotificacion?: string
    
   

    

      ) {}
}




